export const SEO_DEFAULTS = {
  baseUrl: 'https://storily.io',
  siteName: 'Storily',
  defaultImage: 'https://storily.io/og-default.png',
  twitterHandle: '@storymarketing'
};

export const truncateDescription = (text: string, maxLength: number = 155): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};

export const generateCanonicalUrl = (path: string): string => {
  return `${SEO_DEFAULTS.baseUrl}${path}`;
};

export const generateArticleSEO = (article: any) => {
  return {
    title: `${article.title} | ${SEO_DEFAULTS.siteName}`,
    description: truncateDescription(article.excerpt || article.content),
    image: article.featured_image_url || SEO_DEFAULTS.defaultImage,
    canonical: generateCanonicalUrl(`/articles/${article.slug}`),
    type: 'article' as const,
    keywords: article.tags?.map((t: any) => t.name).join(', ')
  };
};
